
 jQuery(document).ready(function($){
	$('#closebanner').click(function() {

		var cname = 'bannerCookie';
		var cvalue = 'yes';
		var exhours = '1';
        var d = new Date();
        d.setTime(d.getTime() + (exhours*24*60*60*1000));
        var expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires + "; " + "path=/";
        $('#emergencywrapper').hide();

    })
 });
 

